"use client"

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        backdropFilter: "blur(4px)",
      }}
      onClick={onClose} // opcional si quieres cerrar al hacer click fuera
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
          width: "90%",
          maxWidth: "900px", // Aumentado para acomodar el diseño de dos columnas
          maxHeight: "90vh",
          overflow: "hidden",
        }}
        onClick={(e) => e.stopPropagation()} // Evita que se cierre al hacer click dentro
      >
        {children}
      </div>
    </div>
  )
}

export default Modal